import { render } from "./Features.vue?vue&type=template&id=277afeb2&scoped=true&bindings={\"featuresData\":\"data\"}"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"

import "./Features.vue?vue&type=style&index=0&id=277afeb2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-277afeb2"

export default script